NtechApp.PersonalAccountForm = function($view) {
    var me = this;

    this._$view = null;
    this._$zipCodeInput = null;
    this._$zipCodeSublabel = null;
    this._$zipCodeHidden = null;

    this._citySelect = null;
    this._birthYearSelect = null;
    this._birthMonthSelect = null;
    this._birthDaySelect = null;

    this._click = null;
    this._ajax = null;
    this._zipCodeAuto = null;

    this._construct = function () {
        me._$view = $view;

        me._$zipCodeInput = me._$view.find("[data-autocompleteid='zipCode']");
        me._$zipCodeSublabel = me._$view.find("[data-autocompleteSublabelId='zipCode']");
        me._$zipCodeHidden = me._$view.find("[data-autocompleteHiddenId='zipCode']");

        me._citySelect = NtechApp.formManager.getFormSelectById("city");
        me._birthYearSelect = NtechApp.formManager.getFormSelectById("birthYear");
        me._birthMonthSelect = NtechApp.formManager.getFormSelectById("birthMonth");
        me._birthDaySelect = NtechApp.formManager.getFormSelectById("birthDay");

        me._click = new NtechApp.TouchClickEvent();
        me._ajax = new NtechApp.Ajax();

        me._zipCodeAuto = new NtechApp.Autocomplete(
            me._$zipCodeInput,
            NtechApp.merge(
                NtechApp.autocompleteSettings.default,
                {matchType: NtechApp.Autocomplete.MATCH_TYPES.START}
            ),
            function() { me._loadZipCodes.apply(me, arguments); }
        );

        me._syncBirthDaySelectState();
        me._bindEvents();
    }

    this._bindEvents = function () {
        var selEv = NtechApp.SelectForm.EVENT_OPTION_SELECT;
        $(me._birthYearSelect).on(selEv, function() {
            me._syncBirthDaySelectState();
        });

        $(me._birthMonthSelect).on(selEv, function() {
            me._syncBirthDaySelectState();
        });

        me._bindZipAutoEvents();
    }

    this._bindSharedEvents = function() {
    }

    this._bindZipAutoEvents = function() {
        $(me._zipCodeAuto).on(NtechApp.Autocomplete.SELECT_EVENT, function(event, id, text, $searchResult) {
            me._$zipCodeSublabel.text(text);
            me._$zipCodeHidden.val(id);

            me._loadCities(id);
        });

        me._click.listen(me._zipCodeAuto.getView(), "[data-loadNextSearchResults]", function(event) {
            if($(event.target).hasClass("lockLoadNextButton"))
                return;

            var $loadNext = $(event.target).addClass("selectedItem lockLoadNextButton");
            var page = $loadNext.attr("data-loadNextSearchResults");

            me._ajax.enableTextLoading($loadNext);
            me._loadZipCodes(
                me._zipCodeAuto.getSearchVal(),
                NtechApp.bind("appendData", me._zipCodeAuto),
                NtechApp.noop,
                page
            );
        });
    }

    this._unbindEvents = function () {
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.PersonalAccountForm.EVENT_WINDOW_RESIZE = "resize.NtechApp.PersonalAccountForm";

NtechApp.proto(NtechApp.PersonalAccountForm, {
    _loadZipCodes: function(searchVal, onFoundData, onNotFoundData, page) {
        var me = this;
        var params = {
            searchType: NtechApp.searchTypes.ZIP_CODES,
            searchText: searchVal,
            searchPage: page || 0
        };

        me._ajax.get({
            url: Routing.generate('search', params),
            onSuccess: function(data) {
                if(data.hasResults)
                    onFoundData(data.html);
                else
                    onNotFoundData(data.html);
            },
            onComplete: function() {
                //if(me._nextLoadRequestData == null)
                //    me._loaderOff();
            }
        });
    },

    _loadCities: function(zipCodeId) {
        var me = this;
        var params = {
            zipCodeId: zipCodeId
        };

        me._citySelect.lock();
        me._citySelect.clearVal();
        me._citySelect.enableLoader();

        me._ajax.get({
            url: Routing.generate('search_cities_by_zip', params),
            onSuccess: function(data) {
                me._updateCitySelect(data.results);
            },
            onComplete: function() {
                me._citySelect.disableLoader();
                //if(me._nextLoadRequestData == null)
                //    me._loaderOff();
            }
        });
    },

    _updateCitySelect: function(citiesData) {
        this._citySelect.unlock();

        var labels = [];
        var vals = [];
        for(var i = 0; i < citiesData.length; i++) {
            labels.push(citiesData[i].name);
            vals.push(citiesData[i].id);
        }

        this._citySelect.reinsertOptions(labels, vals);
    },

    _syncBirthDaySelectState: function() {
        var selectedYearIndex = this._birthYearSelect.getSelectedOptionIndex();
        var selectedMonthIndex = this._birthMonthSelect.getSelectedOptionIndex();

        if(selectedYearIndex === -1 || selectedMonthIndex === -1) {
            this._birthDaySelect.lock();
            return;
        }

        this._recreateBirthDaySelectOptions(selectedMonthIndex);
        this._birthDaySelect.unlock();
    },

    _recreateBirthDaySelectOptions: function(selectedMonthIndex) {
        var selectedYear = this._birthYearSelect.getVal();
        var daysCount = NtechApp.dateTools.getDaysCountInMonth(selectedMonthIndex, selectedYear);
    
        var labels = [];
        var vals = [];
        for(var i = daysCount; i >= 1; i--) {
            labels.push(i);
            vals.push(i);
        }

        this._birthDaySelect.reinsertOptions(labels, vals);
    }
});